import { render, staticRenderFns } from "./fancyDynamicViewTable.vue?vue&type=template&id=2ca6ef6a&scoped=true&"
import script from "./fancyDynamicViewTable.vue?vue&type=script&lang=js&"
export * from "./fancyDynamicViewTable.vue?vue&type=script&lang=js&"
import style0 from "./fancyDynamicViewTable.vue?vue&type=style&index=0&id=2ca6ef6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca6ef6a",
  null
  
)

component.options.__file = "fancyDynamicViewTable.vue"
export default component.exports